/**
 * ActivationLandingScreen — adaptateur primaire de l'arrivée du lien d'activation (route `activation`).
 *
 * Fil mince : le contexte du lien + le view-model → `<ActivationLandingPage>`.
 *
 * Le thème est porté ICI et non par la coquille, contrairement aux onglets : cette page est
 * autonome par construction (écran public, monté hors du navigateur parent, comme les écrans de
 * funnel) — c'est ce qui la rend insensible à l'écran blanc de `/parent-subscription` à froid, et
 * c'est la raison d'être de l'écran. Aucune coquille ne peut donc basculer le thème pour elle.
 */
import { useSelector } from "react-redux"

import { ActivationLandingPage } from "../../../../../../design-system"
import { activationLandingViewModel } from "../../../../view-models/parent/Activation/activationLandingViewModel"
import { readActivationLinkParams, type ActivationRoute } from "./activationLink"
import { useActivationLandingData } from "./useActivationLandingData"
import { useActivationLandingState } from "./useActivationLandingState"
import { useParentThemeScope } from "../../../hooks/useParentThemeScope"

export type ActivationLandingScreenProps = { route?: ActivationRoute }

export function ActivationLandingScreen(props: ActivationLandingScreenProps) {
    useParentThemeScope()

    const linkParams = readActivationLinkParams(props.route)
    const data = useActivationLandingData(linkParams)
    const vm = useSelector((state: unknown) => activationLandingViewModel(state, data.raw, linkParams != null))
    const actions = useActivationLandingState(linkParams, vm.repriseSeason)

    return (
        <ActivationLandingPage
            studentFirstName={vm.studentFirstName}
            product={vm.product}
            nextStep={vm.nextStep}
            notice={vm.notice}
            outcome={vm.outcome}
            loading={vm.loading}
            onActivate={actions.openComposer}
            onEdit={actions.openComposer}
            onNoticeAction={actions.openReprise}
            onOpenSpace={actions.openSpace}
        />
    )
}

export default ActivationLandingScreen
